import { MappingTable } from "@/components/MappingTable";

export const AsIsFieldMapping = () => (
  <MappingTable
    panelTestId="asis-field-mapping-panel"
    subtitleLabel="Current State"
    subtitleColor="text-[#475569]"
    title="As-Is Field Mapping"
    description="Field configuration mapping across all programs"
    showEnhancementStatus={false}
    accentColor="teal"
    testIdPrefix="mapping"
  />
);
